/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_To_All_Event_GroupsInputs */

const en_apply_to_all_event_groups = /** @type {(inputs: Apply_To_All_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply to All Event Groups`)
};

const fr_apply_to_all_event_groups = /** @type {(inputs: Apply_To_All_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer à tous les groupes d’événements`)
};

const de_apply_to_all_event_groups = /** @type {(inputs: Apply_To_All_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gilt für alle Veranstaltungsgruppen`)
};

const it_apply_to_all_event_groups = /** @type {(inputs: Apply_To_All_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica a tutti i gruppi di eventi`)
};

const ru_apply_to_all_event_groups = /** @type {(inputs: Apply_To_All_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить ко всем группам мероприятий`)
};

const es_apply_to_all_event_groups = /** @type {(inputs: Apply_To_All_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar a todos los grupos de eventos`)
};

const zh_cn2_apply_to_all_event_groups = /** @type {(inputs: Apply_To_All_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于所有活动组`)
};

const ja_apply_to_all_event_groups = /** @type {(inputs: Apply_To_All_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのイベントグループに適用`)
};

const hi_apply_to_all_event_groups = /** @type {(inputs: Apply_To_All_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी इवेंट समूहों पर लागू होता है`)
};

const pt_pt2_apply_to_all_event_groups = /** @type {(inputs: Apply_To_All_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar a todos os grupos de eventos`)
};

/**
* | output |
* | --- |
* | "Apply to All Event Groups" |
*
* @param {Apply_To_All_Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_to_all_event_groups = /** @type {((inputs?: Apply_To_All_Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_To_All_Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply_to_all_event_groups(inputs)
	if (locale === "de") return de_apply_to_all_event_groups(inputs)
	if (locale === "it") return it_apply_to_all_event_groups(inputs)
	if (locale === "ru") return ru_apply_to_all_event_groups(inputs)
	if (locale === "es") return es_apply_to_all_event_groups(inputs)
	if (locale === "zh-CN") return zh_cn2_apply_to_all_event_groups(inputs)
	if (locale === "ja") return ja_apply_to_all_event_groups(inputs)
	if (locale === "hi") return hi_apply_to_all_event_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_apply_to_all_event_groups(inputs)
	return en_apply_to_all_event_groups(inputs)
});